'use client';

import { useEffect, useRef } from 'react';
import type { JourneyAnalyticsParams } from '~/utils/journeyAnalytics';

/** The GTM trigger name. Changing it silently stops the GA4 trip-page-view tag firing. */
export const TRIP_VIEW_EVENT = 'lovable_experiment_trip_view';

/**
 * Puts the blueprint_card_click parameters into the dataLayer, because a page view has no click
 * element to read them off. Values are derived on the server, from the journey.
 *
 * It must be an event rather than a bare state push, and the GTM trigger a Custom Event rather than
 * a Page View: GTM's page_view fires at container load, long before this. GTM processes the whole
 * dataLayer queue, so an event fires its trigger whenever it lands.
 */
export function DataLayerSeed({ lpSource, blueprintId }: JourneyAnalyticsParams) {
  const hasPushed = useRef(false);

  useEffect(() => {
    if (hasPushed.current) return;
    hasPushed.current = true;

    globalThis.dataLayer = globalThis.dataLayer || [];
    // Both keys always present: GTM merges pushes, so omitting one keeps the previous page's value.
    globalThis.dataLayer.push({
      event: TRIP_VIEW_EVENT,
      lp_source: lpSource || null,
      blueprint_id: blueprintId || null
    });
  }, [lpSource, blueprintId]);

  return null;
}
